export default __webpack_public_path__ + "static/media/icon_1.61cafb55.svg";